export default "__VITE_ASSET__DHbS44u2__"